module.exports = __webpack_public_path__ + "assets/img/ctm-fill-bill.8285215d.png";